// extracted by mini-css-extract-plugin
module.exports = {"containerMobile":"PageTitle_containerMobile__1w2oH","containerPc":"PageTitle_containerPc__36c7M","title":"PageTitle_title__Zqh0g"};